import { render } from "./CadCursos.vue?vue&type=template&id=f5047f9e"
import script from "./CadCursos.vue?vue&type=script&lang=js"
export * from "./CadCursos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__